import { render } from "./Oferta.vue?vue&type=template&id=12e112ae"
import script from "./Oferta.vue?vue&type=script&lang=js"
export * from "./Oferta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__